// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// sudo-wrapper imports
import { IContainer, IProps, IState } from "./SudoWrapper.d";
import { sudoWrapperFragments, sudoWrapperQuery } from "./SudoWrapper.gql";
import { styles } from "./SudoWrapper.styles";
import { SudoSwitchUser } from "@components/sudo-switch-user";
import { SudoModifyUser } from "@components/sudo-modify-user";
import { SudoDeactivateUser } from "@components/sudo-deactivate-user";
import { SudoDeleteEverything } from "@components/sudo-delete-everything";
import { SudoTriggerClientUpdate } from "@components/sudo-trigger-client-update";
import { SudoCli } from "@components/sudo-cli";

// state
import { IReduxState } from "@reducers/root.reducer";

// routing
import { withRouteQuery } from "@routing/routes.util";

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";

///////////////
// Component //
///////////////
class SudoWrapperCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const env = process.env.NODE_ENV;
    return (
      <div className={this.props.classes.container}>
        <SudoSwitchUser viewer={this.props.viewer} />
        <SudoModifyUser viewer={this.props.viewer} />
        <SudoDeactivateUser viewer={this.props.viewer} />
        <SudoTriggerClientUpdate sudo={this.props.viewer.sudo} />
        {env && env !== "production" ? <SudoDeleteEverything viewer={this.props.viewer} /> : ""}
        <SudoCli />
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const SudoWrapperStyled = withStyles(styles)(SudoWrapperCmpt);

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SudoWrapperRedux = connect(mapStateToProps, {})(SudoWrapperStyled);

///////////
// Relay //
///////////
export const SudoWrapper = createFragmentContainer<IContainer>(
  SudoWrapperRedux,
  sudoWrapperFragments,
);

export const SudoWrapperPage = withRouteQuery(SudoWrapper, sudoWrapperQuery);
